'use client';

import { SidebarLayout } from '@widgets/sidebar-layout';

import { language, useProfileSidebarLinks } from '../model';
import Image from 'next/image';

export const ProfileLayout = ({ children }: { children: React.ReactNode }) => {
  const sidebarLinks = useProfileSidebarLinks();

  return (
    <SidebarLayout
      title={language.profile}
      sidebarLinks={sidebarLinks}
      sidebarIcon={
        <Image
          unoptimized
          src='/images/profilepicture.png'
          alt=''
          width={100}
          height={100}
          className='rounded-full my-[40px]'
        />
      }
    >
      {children}
    </SidebarLayout>
  );
};
